import React from 'react';

export const SUPPORTED_LANGUAGES = ['en', 'es', 'pt', 'fr'] as const;
export type LanguageCode = (typeof SUPPORTED_LANGUAGES)[number];

export const getCurrentLanguage = (resolvedLanguage: string | undefined): LanguageCode => {
  const lang = (resolvedLanguage ?? 'en') as LanguageCode;
  return SUPPORTED_LANGUAGES.includes(lang) ? lang : 'en';
};

export function applyLanguageValueChange(
  details: { value: string[] },
  setSelectedLanguage: React.Dispatch<React.SetStateAction<LanguageCode>>,
): void {
  const code = details.value[0] as LanguageCode | undefined;
  if (code != null && SUPPORTED_LANGUAGES.includes(code)) {
    setSelectedLanguage(code);
  }
}
